import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@card-software/library';
import { environment } from '@environments/environment';
import { SigningAuthenticatorEnrollment, SigningAuthenticatorStatus } from '@app/models/signing-session/signing-session';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SigningAuthenticatorProxyService {
  private baseUrl = `${environment.proxyUrls.userMasterApi}/api/v1/signing-authenticator`;

  constructor(private httpClient: HttpClient) {}

  getStatus(): Observable<ApiResponse<SigningAuthenticatorStatus>> {
    return this.httpClient.get<ApiResponse<SigningAuthenticatorStatus>>(`${this.baseUrl}/status`);
  }

  startEnrollment(password: string): Observable<ApiResponse<SigningAuthenticatorEnrollment>> {
    return this.httpClient.post<ApiResponse<SigningAuthenticatorEnrollment>>(`${this.baseUrl}/enrollment`, { password });
  }

  confirmEnrollment(code: string): Observable<ApiResponse<SigningAuthenticatorStatus>> {
    return this.httpClient.post<ApiResponse<SigningAuthenticatorStatus>>(`${this.baseUrl}/enrollment/confirm`, { code });
  }

  reset(username: string): Observable<ApiResponse<unknown>> {
    return this.httpClient.delete<ApiResponse<unknown>>(`${this.baseUrl}/users/${encodeURIComponent(username)}`);
  }
}
